<div class="flexie-auto-grid m-t-b-60">
  <div class="flex-self-vert-start">
    <div *ngIf="addressList && addressList.length < 1">
      <div class="zero-ui">
        <i nz-icon nzType="schedule" theme="outline"></i>
        <h2 translate>Add Address</h2><span style="margin-left: 6px;" class ="col-grey-light cur-pointer" nz-tooltip nzTooltipTitle="Add Address Details"><i nz-icon nzType="exclamation-circle" class="ico-item"></i></span>
        <p translate>You need to at-least one address to continue</p>
      </div>
    </div>
    <div *ngIf="addressList && addressList.length > 0">
      <h3 translate> Address</h3>
      <div *ngFor="let item of addressList; let i = index;"
        class="flex flex-dir-horiz flex-horiz-space-bw flex-vert-center b-b-1 p-10">
        <div style="flex: 1;">
          <label nz-checkbox nz-tooltip [nzTitle]="'Mark as preferred'" [(ngModel)]="item.prefferedFl"
            (ngModelChange)="deselectOtherAddresssesPrefferedFl(i)"></label>&nbsp;
          <strong>{{item.typeCd || '' }}</strong>
          <br>
          <span style = "text-transform:capitalize;">
          {{item.addressLine1 || '' |translate}},{{item.addressLine2 || '' |translate}},{{item.addressLine3 || '' |translate}},
          {{item?.postCode }}, {{item?.cityCd | technicalTranslate : 'cityCd'}}, {{item?.stateCd | technicalTranslate : 'stateCd'}},
          {{item?.countryCd | technicalTranslate : 'countryCd'}}</span>
        </div>
        <div>
          <a href="javascript:void(0)" (click)="editAddress(item,i)"><span nz-icon nzType="edit" nzTheme="outline"></span></a> |
          <a style="color: red;" href="javascript:void(0)" (click)="removeAddress(item,i)"><span nz-icon nzType="delete" nzTheme="outline"></span></a>
        </div>
      </div>
    </div>
  </div>
  <div style="align-self: flex-start !important;">
    <div class="form-secondary">
      <h3 class="form-secondary-heading" translate>+ Add Address</h3>
      <form [formGroup]="uiAddressIndForm" class="form-secondary-fields p-l-r-20 p-t-b-10">
        <nz-form-item *ngIf="!removeAddressType">
          <nz-form-label nzFor="typeCd" [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('typeCd', UIADDRESSINDFORMNAME)"><span translate>Type</span>
          </nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-select nzShowSearch  id="typeCd" formControlName="typeCd" style="width: 100%" [nzDisabled]="defaultTypeCd" [nzDisabled]="viewType">
              <nz-option
                *ngFor="let item of (lookup$.addressTypeCd | async) as addressTypeCdLookup; trackBy:item?.lookupKey"
                [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
            </nz-select>
            <!--  -->
            <nz-form-explain
              *ngIf="(uiAddressIndForm.get('typeCd').dirty || uiAddressIndForm.get('typeCd').touched) && uiAddressIndForm.get('typeCd').errors">
              <p style="color:red"
                *ngFor="let error of validationUtilService.getUIErrorList(uiAddressIndForm.get('typeCd'), UIADDRESSINDFORMNAME)">
                {{error.errorMessage || error }}</p>
            </nz-form-explain>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label  [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('addressLine1', UIADDRESSINDFORMNAME)"><span translate>Address Line 1, 2, 3</span></nz-form-label>
          <nz-form-control [nzSpan]="24">
           <input nz-input style="text-transform: capitalize;" placeholder="{{'Address Line 1' | translate}}" formControlName="addressLine1" />
            <nz-form-explain
              *ngIf="(uiAddressIndForm.get('addressLine1').dirty || uiAddressIndForm.get('addressLine1').touched) && uiAddressIndForm.get('addressLine1').errors">
              <p style="color:red"
                *ngFor="let error of validationUtilService.getUIErrorList(uiAddressIndForm.get('addressLine1'), UIADDRESSINDFORMNAME)">
                {{error.errorMessage || error }}</p>
            </nz-form-explain>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control [nzSpan]="24">
            <input nz-input style="text-transform: capitalize;" placeholder="{{'Address Line 2' | translate}}" formControlName="addressLine2" />
            <nz-form-explain
              *ngIf="(uiAddressIndForm.get('addressLine2').dirty || uiAddressIndForm.get('addressLine2').touched) && uiAddressIndForm.get('addressLine2').errors">
              <p style="color:red"
                *ngFor="let error of validationUtilService.getUIErrorList(uiAddressIndForm.get('addressLine2'), UIADDRESSINDFORMNAME)">
                {{error.errorMessage || error }}</p>
            </nz-form-explain>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control [nzSpan]="24">
            <input nz-input style="text-transform: capitalize;" placeholder="{{'Address Line 3' | translate}}" formControlName="addressLine3" />
            <nz-form-explain
              *ngIf="(uiAddressIndForm.get('addressLine3').dirty || uiAddressIndForm.get('addressLine3').touched) && uiAddressIndForm.get('addressLine3').errors">
              <p style="color:red"
                *ngFor="let error of validationUtilService.getUIErrorList(uiAddressIndForm.get('addressLine3'), UIADDRESSINDFORMNAME)">
                {{error.errorMessage || error }}</p>
            </nz-form-explain>
          </nz-form-control>
        </nz-form-item>
        <div class="flexie-auto-grid">
          <div>
            <label nz-checkbox formControlName="enableSearchByPinCode" (ngModelChange)="enableDisableSearchByPin()">
              Enable Search By PinCode</label>
          </div>
        </div>
        <!-- 3 -->
        <div class="flexie-auto-grid">
          <div>
            <nz-form-item>
              <nz-form-label [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('postCode', UIADDRESSINDFORMNAME)"><span translate>PIN Code</span></nz-form-label>
              <nz-form-control id="pincodeInput" [nzSpan]="24">
                <!-- <input nz-input placeholder="Pin Code" formControlName="postCode" /> -->
                <ng-container *ngIf="uiAddressIndForm.value.enableSearchByPinCode">
                  <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
                    <input nz-input formControlName="postCode" />
                  </nz-input-group>
                </ng-container>
                <ng-container *ngIf="!uiAddressIndForm.value.enableSearchByPinCode">
                  <input nz-input formControlName="postCode" />
                </ng-container>
                <ng-template #suffixIconButton>
                  <button (click)="fetchProvinceandCityByPostCode()" nz-button nzType="primary" nzShape="round" class="d-b w-100-pc"><i
                      nz-icon nzType="search"></i></button>
                </ng-template>
                <nz-form-explain
                  *ngIf="(uiAddressIndForm.get('postCode').dirty || uiAddressIndForm.get('postCode').touched) && uiAddressIndForm.get('postCode').errors">
                  <p style="color:red"
                    *ngFor="let error of validationUtilService.getUIErrorList(uiAddressIndForm.get('postCode'), UIADDRESSINDFORMNAME)">
                    {{error.errorMessage || error }}</p>
                </nz-form-explain>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div>
            <nz-form-item>
              <nz-form-label nzFor="country" [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('countryCd', UIADDRESSINDFORMNAME)"><span
                  translate>Country</span>
              </nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-select nzShowSearch id="country" formControlName="countryCd"
                 style="width: 100%" (ngModelChange)="countrySelected()">
                  <!-- [class.inputs-are-disabled]="!disableDefaultCountryOnly" [nzDisabled]="!disableDefaultCountryOnly"> -->
                  <nz-option
                    *ngFor="let item of (lookup$.countryCd | async) as countryCdLookup; trackBy:item?.lookupKey"
                    [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                </nz-select>
                <!--  -->
                <nz-form-explain
                  *ngIf="(uiAddressIndForm.get('countryCd').dirty || uiAddressIndForm.get('countryCd').touched) && uiAddressIndForm.get('countryCd').errors">
                  <p style="color:red"
                    *ngFor="let error of validationUtilService.getUIErrorList(uiAddressIndForm.get('countryCd'), UIADDRESSINDFORMNAME)">
                    {{error.errorMessage || error }}</p>
                </nz-form-explain>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="flexie-auto-grid">
          <div>
            <nz-form-item>
              <nz-form-label nzFor="stateCd" [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('stateCd', UIADDRESSINDFORMNAME)"><span
                  translate>State</span></nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-select nzShowSearch id="stateCd"
                  formControlName="stateCd" (ngModelChange)="provinceSelected()" style="width: 100%">
                  <nz-option *ngFor="let item of (provinceCd$ | async) as stateCdLookup; trackBy:item?.lookupKey"
                    [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                </nz-select>
                <!--  -->
                <nz-form-explain
                  *ngIf="(uiAddressIndForm.get('stateCd').dirty || uiAddressIndForm.get('stateCd').touched) && uiAddressIndForm.get('stateCd').errors">
                  <p style="color:red"
                    *ngFor="let error of validationUtilService.getUIErrorList(uiAddressIndForm.get('stateCd'), UIADDRESSINDFORMNAME)">
                    {{error.errorMessage || error }}</p>
                </nz-form-explain>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div>
            <nz-form-item>
              <nz-form-label [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('cityCd', UIADDRESSINDFORMNAME)"><span
                  translate>City</span></nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-select nzShowSearch id="cityCd"
                  formControlName="cityCd" style="width: 100%">
                  <nz-option *ngFor="let item of (cityCd$ | async) as eventTypeCdLookup; trackBy:item?.lookupKey"
                    [nzLabel]="item?.cityName" [nzValue]="item?.cityCd"></nz-option>
                </nz-select>
                <nz-form-explain
                  *ngIf="(uiAddressIndForm.get('cityCd').dirty || uiAddressIndForm.get('cityCd').touched) && uiAddressIndForm.get('cityCd').errors">
                  <p style="color:red"
                    *ngFor="let error of validationUtilService.getUIErrorList(uiAddressIndForm.get('cityCd'), UIADDRESSINDFORMNAME)">
                    {{error.errorMessage || error }}</p>
                </nz-form-explain>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </form>
      <div class="footer-actions-bar">
        <div>
          <!-- Left -->
        </div>
        <div>
          <!-- Right -->
          <button nz-button class="b-0 m-r-10" (click)="clearForm()"><span translate>Clear</span></button>
          <button nz-button [nzType]="'primary'" (click)="addAddress()"><span translate>Add</span></button>
        </div>
      </div>
    </div>
  </div>
</div>
